import type { FC } from 'react'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { FaqAgroservicesBanner } from '@/components/composed'
import { Breadcrumbs } from '@/components/ui'
import { injectMessages } from '@/logic/translation/utils'
import { FieldEvaluationReportDialogPublicLauncher } from '@/pages/Financing/components/FieldEvaluationReportDialogPublicLauncher'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import { FaqSearchInput } from '../FaqSearch/components'
import FaqMainPage from './components/FaqMainPage'
import { breadcrumbs } from './constants'
import messages from './messages.json'
import './styles.scss'

injectMessages(messages)

const Faq: FC = () => {
  const { isMobile } = useDeviceType()

  return (
    <>
      <div className="page-wrapper">
        <Breadcrumbs customBreadcrumbs={breadcrumbs} isMobile={isMobile} />
        <div className="faq__header-container">
          <h2 className="faq__title">
            <FormattedMessage id="faq.title" />
          </h2>
          <FaqSearchInput shouldRedirectToSearchingPage className="faq-categories-search" />
        </div>
      </div>
      <FaqMainPage />
      <FaqAgroservicesBanner className="faq__agroconsulting-banner" />
      <FieldEvaluationReportDialogPublicLauncher comment={messages.ru['fieldEvaluationReportDialog.comment']} />
    </>
  )
}

export default Faq
